<template>
  <div class="mcl-page">
    <slot name="success"></slot>

    <div v-if="!successMoviment">
      <div v-show="loading" class="mcl-loading">
        <Loading type="line" :center="true" />
        <p class="mcl-loading-text">{{ loadingText }}</p>
      </div>

      <div v-show="!loading">
        <div class="mcl-header">
          <div class="mcl-header-title">
            <span class="mcl-title">
              <i :class="titleIcon"></i>
              {{ title }}
            </span>
          </div>
          <div v-if="$slots['periods']" class="mcl-periods">
            <slot name="periods"></slot>
          </div>
        </div>

        <slot name="recalculate"></slot>

        <div class="mcl-table-wrap">
          <div class="mcl-table-topbar">
            <span class="mcl-total-badge">
              Total {{ totalItems }} {{ totalItems === 1 ? 'registro' : 'registros' }}
            </span>
          </div>
          <ScrollBar :minHeight="0" :maxHeight="600">
            <table class="mcl-table">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Descrição</th>
                  <th class="mcl-th-center">Locação</th>
                  <th class="mcl-th-center">{{ qtyColumnLabel }}</th>
                  <slot name="extra-th"></slot>
                  <th class="mcl-th-center">Status</th>
                  <slot name="extra-th-end"></slot>
                </tr>
              </thead>
              <slot name="rows"></slot>
              <tbody v-show="totalItems === 0">
                <tr>
                  <td colspan="12" class="mcl-empty">Nenhum produto encontrado!</td>
                </tr>
              </tbody>
            </table>
          </ScrollBar>
        </div>

        <slot name="alerts"></slot>

        <div class="mcl-actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>

    <slot name="modals"></slot>
  </div>
</template>

<script>
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

export default {
  name: "MovimentCheckLayout",
  components: { ScrollBar, Loading },
  props: {
    title: { type: String, required: true },
    titleIcon: { type: String, default: "fa-solid fa-clipboard-check" },
    loading: { type: Boolean, default: false },
    totalItems: { type: Number, default: 0 },
    successMoviment: { type: Boolean, default: false },
    loadingText: { type: String, default: "Aguarde..." },
    qtyColumnLabel: { type: String, default: "Saída" },
  },
};
</script>

<style>
.mcl-page {
  padding: 16px 4px 24px;
  font-family: inherit;
}

.mcl-loading {
  padding: 20px 0;
  text-align: left;
}

.mcl-loading-text {
  margin-top: 10px;
  font-size: 14px;
}

.mcl-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.mcl-header-title {
  width: 100%;
  text-align: center;
}

.mcl-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #374151;
}

.mcl-title-icon {
  font-size: 18px;
  color: #6b7280;
}

.mcl-periods {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
}

.mcl-period-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
}

.mcl-period-pill--final {
  background: #ffffff;
  border-color: #d1d5db;
}

.mcl-period-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9ca3af;
}

.mcl-period-value {
  color: #374151;
}

.mcl-btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: 1px solid #d5dae6;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12px;
  color: #5b6478;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.mcl-btn-edit:hover {
  background: #edf0f7;
  color: #2c3345;
}

.mcl-recalculate {
  margin-bottom: 14px;
}

.mcl-table-wrap {
  border: 1px solid #e8ecf3;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}

.mcl-table-topbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 16px 8px;
  border-bottom: 1px solid #edf0f7;
}

.mcl-total-badge {
  font-size: 12.5px;
  font-weight: 600;
  color: #6b7280;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 3px 12px;
}

.mcl-table {
  width: 100%;
  border-collapse: collapse;
}

.mcl-table thead tr {
  background: #f9fafb;
}

.mcl-table thead th {
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  border-bottom: 1px solid #eef0f3;
}

.mcl-th-center {
  text-align: center !important;
}

.mcl-tr {
  border-bottom: 1px solid #f0f3f8;
  transition: background 0.15s;
}

.mcl-tr:hover {
  background: #fafbfd;
}

.mcl-table tbody td {
  padding: 10px 12px;
  font-size: 14px;
  color: #374151;
  vertical-align: middle;
}

.mcl-td-product {
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
}

.mcl-td-desc {
  max-width: 280px;
  word-wrap: break-word;
  font-size: 13px;
  color: #6b7280;
  font-style: italic;
}

.mcl-qty-badge {
  display: inline-block;
  min-width: 36px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.mcl-qty-badge--rent {
  background: #edf0f8;
  color: #4a5571;
}

.mcl-qty-badge--return {
  background: #e9f3ea;
  color: #2d7a34;
}

.mcl-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background: none;
  padding: 0;
  border-radius: 0;
  border: none;
}

.mcl-status--success {
  color: #1d9e1d;
}

.mcl-status--warning {
  color: #f6bb2a;
}

.mcl-status--danger {
  color: #c62828;
}

.mcl-status--primary {
  color: #1a3fbd;
}

.mcl-tr-patrimony td {
  padding: 0 !important;
}

.mcl-td-patrimony {
  background: transparent;
  border-bottom: 1px solid #f0f3f8;
  padding: 12px 16px 12px 44px !important;
  width: 100%;
  box-sizing: border-box;
}

.mcl-patrimony-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 3px 0;
}

.mcl-patrimony-code {
  display: none;
}

.mcl-patrimony-icon {
  display: none;
}

.mcl-empty {
  text-align: center;
  padding: 24px !important;
  color: #9ca3af;
  font-size: 14px;
}

.mcl-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 18px;
  padding-top: 14px;
  flex-wrap: wrap;
}

.mcl-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1.5px solid #b8bfcc;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  flex-shrink: 0;
}

.mcl-checkbox:checked {
  background: #3c4459;
  border-color: #3c4459;
}

.mcl-checkbox:checked::after {
  content: "✔";
  position: absolute;
  top: -4px;
  left: 2px;
  font-size: 12px;
  color: #fff;
}

@media (max-width: 992px) {
  .mcl-header {
    flex-direction: column;
  }
  .mcl-periods {
    flex-direction: column;
    align-items: flex-start;
  }
  .mcl-period-pill {
    width: 100%;
    max-width: 420px;
  }
  .mcl-td-product {
    white-space: normal;
  }
  .mcl-td-patrimony {
    padding: 8px 12px 8px 16px !important;
  }
}
</style>

